<template>
  <v-container>
    <v-row>
      <v-col md="8" lg="9">
        <router-view></router-view>
      </v-col>
      <v-col md="4" lg="3">
        <v-card
            outlined
        >
          <v-card-title>
            <v-icon left>mdi-account-circle</v-icon>
            {{ $t('user.admin_panel') }}
          </v-card-title>
          <v-card-text>
            <v-divider></v-divider>
            <br>
            <v-list dense>
              <v-list-item :to="{ name: 'user-list'}">
                <v-list-item-icon>
                  <v-icon>mdi-account-multiple</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  {{ $t('admin_panel.users.title') }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item :to="{ name: 'radar-list'}">
                <v-list-item-icon>
                  <v-icon>mdi-radar</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  {{ $t('admin_panel.radars.title') }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item :to="{ name: 'suggestion-blobs'}">
                <v-list-item-icon>
                  <v-icon>mdi-lightbulb</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  {{ $t('admin_panel.suggestion-blobs.title') }}
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import adminStoreModule from '@/store/modules/admin.js'

export default {
  name: 'Admin',
  created () {
    // register admin store module
    this.$store.registerModule('admin', adminStoreModule)
  },
  beforeDestroy () {
    // unregister admin store module
    this.$store.unregisterModule('admin')
  }
}
</script>

<style scoped>

</style>
